/*
  Filter drawer: the footer button says how many products the current choice gives ("Show 42 products") and
  updates as soon as something is ticked. The number comes from the same section render the theme itself fetches
  (data-ns-count on the product list). Loaded only on collection pages (sections/main-collection.liquid).
*/
(() => {
  let ctrl = null;
  const label = (btn, n) => {
    const t = n === 0 ? btn.dataset.none : n === 1 ? btn.dataset.one : btn.dataset.many.replace('[count]', n);
    if (btn.textContent !== t) btn.textContent = t;
  };
  document.addEventListener('change', async (event) => {
    const form = event.target.closest('facets-drawer form[is="facets-form"]');
    if (!form) return;
    const btn = form.closest('facets-drawer').querySelector('[data-ns-show]');
    if (!btn) return;
    /* same URL the theme builds (js/common/facets/facets-form.js) */
    const url = new URL(form.action);
    new URLSearchParams(new FormData(form)).forEach((value, key) => url.searchParams.append(key, value));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => { if (url.searchParams.get(k) === '') url.searchParams.delete(k); });
    url.searchParams.set('section_id', form.getAttribute('section-id'));
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    btn.closest('button')?.setAttribute('aria-busy', 'true');
    try {
      const html = await (await fetch(url, { signal: ctrl.signal })).text();
      const m = html.match(/data-ns-count="(\d+)"/);
      if (m) label(btn, Number(m[1]));
    } catch (e) { /* aborted by a newer change */ }
    btn.closest('button')?.removeAttribute('aria-busy');
  });

  /* The drawer focuses its first control when it opens. For touch and mouse that is just a gold ring on
     "Featured"; keyboard users (opened with Enter/Space) keep it. */
  let byKeyboard = false;
  document.addEventListener('keydown', () => { byKeyboard = true; }, true);
  document.addEventListener('pointerdown', () => { byKeyboard = false; }, true);
  document.addEventListener('dialog:after-show', (event) => {
    if (byKeyboard || !event.target.matches?.('facets-drawer')) return;
    const el = document.activeElement;
    if (el && el.classList.contains('ns-facet-input')) el.blur();
  }, true); /* the event does not bubble: listen in the capture phase */
})();

/*
  Cards follow the colour filter (28 Sep): when Colour (tags "colour:X" or a Color option filter) is active, every
  card switches to its matching colour by pressing its own colour swatch, so image, price and link all follow.
  Runs on load and whenever the grid is re-rendered by a filter change.
*/
(() => {
  const norm = (v) => String(v || '').trim().toLowerCase().replace(/^cr[eè]me$|^cream$/, 'beige');
  const activeColours = () => {
    const q = new URLSearchParams(location.search), out = [];
    q.getAll('filter.p.tag').forEach((v) => { if (/^colou?r:/i.test(v)) out.push(norm(v.split(':').slice(1).join(':'))); });
    ['filter.v.option.color', 'filter.v.option.colour'].forEach((k) => q.getAll(k).forEach((v) => out.push(norm(v))));
    return out;
  };
  let tries = 0;
  const nsCardsFollowColour = () => {
    const wanted = activeColours();
    if (!wanted.length) return;
    const key = wanted.join('|');
    let retry = false;
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card.dataset.nsColour === key) return;
      card.dataset.nsColour = key;
      const swatches = [...card.querySelectorAll('.card-color-swatch[data-color-value]')];
      if (!swatches.length) return;
      const current = card.querySelector('.card-color-swatch.is-selected');
      if (current && wanted.includes(norm(current.dataset.colorValue))) return;
      for (const w of wanted) {
        const hit = swatches.find((s) => norm(s.dataset.colorValue) === w);
        if (!hit) continue;
        if (!hit.__bound) { delete card.dataset.nsColour; retry = true; break; } /* card script not bound yet */
        hit.click();
        break;
      }
    });
    if (retry && tries++ < 20) setTimeout(nsCardsFollowColour, 200);
  };
  window.nsCardsFollowColour = nsCardsFollowColour;
  const run = () => requestAnimationFrame(nsCardsFollowColour);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return; queued = true;
    setTimeout(() => { queued = false; nsCardsFollowColour(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
